<template>
  <v-sheet style="background-color: #001E4A;">
    <v-container class="mt-12 mb-12">
      <v-row style="text-align: center; justify-content: center; color: white">
        <h1 :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 30px' : 'font-size: 22px'">
          {{ $t('callToAction.title') }}
        </h1>
        <p :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 17px' : 'font-size: 20px'">
          {{ $t('callToAction.subtitle') }}
        </p>
        <v-btn
          :loading="loading3"
          :disabled="loading3"
          color="secondary"
          class="ma-2 white--text"
          @click="
            openNewTab(
              'https://api.whatsapp.com/send?phone=5531997076411&text=Olá,%20Antônio.%20Me%20conte%20mais%20sobre%20as%20soluções%20da%20Criptonomia.'
            )
          "
        >
          {{ $t('callToAction.express') }}
          <v-icon right dark>
            mdi-whatsapp
          </v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <div id="waveTop"></div>
  </v-sheet>
</template>

<script>
import Products from 'Assets/Produtos/products.png';
export default {
  name: 'Specialty',
  data() {
    return {
      Products,
    };
  },
  components: {},
  methods: {
    openNewTab(obj) {
      window.open(obj);
    },
  },
};
</script>
